var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreyCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.53198,
  cy: 8,
  r: 7,
  stroke: "#E3EBF6",
  strokeWidth: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreyCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grey-circle.3ba9f7bf87e751bb2ff5d64a52021a66.svg";